export default {
  route: {
    upData: 'upData',
    studyList: 'studyList',
    aiAnalysis: 'aiAnalysis',
    peoples: 'peoples',
    muList: 'muList',
    hospitalList: 'hospitalList',
    userList: 'userList',
    role: 'role',
    cloudAcc: 'cloudAcc',
    muAcc: 'muAcc',
    hospitalAcc: 'hospitalAcc',
    myShift: 'myShift',
    statistics: 'statistics',
    editReport: 'editReport',
    checkReport: 'checkReport',
    personalCenter: 'personalCenter'
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard',
    github: 'Github',
    theme: 'Theme',
    size: 'Global Size'
  },
  login: {
    title: 'Login Form',
    logIn: 'Log in',
    username: 'Username',
    password: 'Password',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !'
  },
  common: {
    Male: 'Male',
    Female: 'Female', 
    unknown: 'unknown',
    pleaseChoose: 'please choose',
    pleaseEnter: 'please enter',
    Isfast: {
      ordinary: 'ordinary',
      hospitalized: 'hospitalized',
      emergency: 'emergency',
      greenChannel: 'greenChannel',
      examination: 'examination'
    }
  },
  upData: {
    uploadFile: 'uploadFile',
    uploadImage: 'uploadImage',
    clickToUpload: 'clickToUpload',
    uploadNotice1: 'Please upload the compressed package of the DICOM image folder (zip. or tar. format)',
    uploadNotice2: 'Please upload jpg/png file',
    pleaseUpload: 'pleaseUpload',
    imageInformation: 'imageInformation',
    applyformurl: 'applyformurl',
    medicalhistory: 'medicalhistory',
    diagnosishistory: 'diagnosishistory',
    patientname: 'patientname',
    sex: 'sex',
    age: 'age',
    birthday: 'birthday',
    studyid: 'studyid',
    accessionnumber: 'accessionnumber',
    patientid: 'patientid',
    Isfast: 'Isfast',
    studydate: 'studydate',
    studytimes: 'studytimes',
    modality: 'modality',
    studyparts: 'studyparts',
    upHospital: 'upHospital',
    save: 'save',
    upload: 'upload',
    message: {
      uploadSuccess: 'uploadSuccess',
      imagePlease: 'Please upload a picture',
      successfullySaved: 'Successfully saved',
      uploadFile: 'Please upload file',
      noCommonFile: 'Cannot upload the same file',
      fileExists:'File already exists'
    }
  },
  studyList: {
    meargewhere: 'meargewhere',
    mainkeys: 'name/patientid/studyid',
    starttime: 'starttime',
    endtime: 'endtime',
    ispay: 'ispay',
    likecontent: 'likecontent',
    store: 'store',
    // queryType
    thisHospital: 'thisHospital',
    remotely: 'remotely',
    mine: 'mine',
    all: 'all',
    notReported: 'not Reported',
    toBePublished: 'to Be Published',
    notReviewed: 'not Reviewed',
    audited: 'audited',
    // table
    totalcount: 'totalcount',
    hospitalname: 'hospitalname',
    patientid: 'patientid',
    studyid: 'studyid',
    patientname: 'patientname',
    age: 'age',
    modality: 'modality',
    studyparts: 'studyparts',
    studystate: 'studystate',
    servicetime: 'servicetime',
    states: 'states',
    reportdocname: 'reportdocname',
    checkdocname: 'checkdocname',
    applydatetime: 'applydatetime',
    studydate: 'studydate',
    uploadtime: 'uploadtime',
    reporttype: 'reporttype',
    reportresult: 'reportresult',
    opreation: 'actions',
    btn: {
      report: 'report',
      reading: 'reading',
      apply: 'apply',
      reapply: 'reapply'
    }
  },
  documentation: {
    documentation: 'Documentation',
    github: 'Github Repository'
  },
  permission: {
    addRole: 'New Role',
    editPermission: 'Edit Permission',
    roles: 'Your roles',
    switchRoles: 'Switch roles',
    tips: 'In some cases it is not suitable to use v-permission, such as element Tab component or el-table-column and other asynchronous rendering dom cases which can only be achieved by manually setting the v-if.',
    delete: 'Delete',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },
  guide: {
    description: 'The guide page is useful for some people who entered the project for the first time. You can briefly introduce the features of the project. Demo is based on ',
    button: 'Show Guide'
  },
  components: {
    documentation: 'Documentation',
    tinymceTips: 'Rich text editor is a core part of management system, but at the same time is a place with lots of problems. In the process of selecting rich texts, I also walked a lot of detours. The common rich text editors in the market are basically used, and the finally chose Tinymce. See documentation for more detailed rich text editor comparisons and introductions.',
    dropzoneTips: 'Because my business has special needs, and has to upload images to qiniu, so instead of a third party, I chose encapsulate it by myself. It is very simple, you can see the detail code in @/components/Dropzone.',
    stickyTips: 'when the page is scrolled to the preset position will be sticky on the top.',
    backToTopTips1: 'When the page is scrolled to the specified position, the Back to Top button appears in the lower right corner',
    backToTopTips2: 'You can customize the style of the button, show / hide, height of appearance, height of the return. If you need a text prompt, you can use element-ui el-tooltip elements externally',
    imageUploadTips: 'Since I was using only the vue@1 version, and it is not compatible with mockjs at the moment, I modified it myself, and if you are going to use it, it is better to use official version.'
  },
  table: {
    query: 'Query',
    export: 'Export',
    actions: 'Actions',
    cancel: 'Cancel',
    confirm: 'Confirm',
    collapse: 'Collapse',
    expand: 'Expand',
  },
  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },
  excel: {
    export: 'Export',
    selectedExport: 'Export Selected Items',
    placeholder: 'Please enter the file name(default excel-list)'
  },
  zip: {
    export: 'Export',
    placeholder: 'Please enter the file name(default file)'
  },
  pdf: {
    tips: 'Here we use window.print() to implement the feature of downloading pdf.'
  },
  theme: {
    change: 'Change Theme',
    documentation: 'Theme documentation',
    tips: 'Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  settings: {
    title: 'Page style setting',
    theme: 'Theme Color',
    tagsView: 'Open Tags-View',
    fixedHeader: 'Fixed Header',
    sidebarLogo: 'Sidebar Logo'
  }
}
